import React from 'react';
import { X } from 'lucide-react';
export function FailedAttempts() {
  const items = [{
    title: 'Manuales universitarios:',
    desc: 'Pura teoría biológica. Sin actividades ni ejemplos para el aula técnica.'
  }, {
    title: 'Papers científicos:',
    desc: 'Para investigadores. Inútiles para el docente que tiene clase el lunes a las 7 AM.'
  }, {
    title: 'Material de la FAO o Senasa:',
    desc: 'Genérico, muy normativo y sin estructura pedagógica para el pibe de secundaria.'
  }, {
    title: 'Grupos de WhatsApp:',
    desc: 'Retazos de información sin progresión. Tenés que armar el rompecabezas solo.'
  }];
  return <section className="py-7 px-4 bg-brand-creamAlt border-y-2 border-brand-line" data-id="element-64">
      <div className="max-w-3xl mx-auto" data-id="element-65">
        <h2 className="text-xl md:text-3xl font-display font-bold text-brand-navy text-center uppercase leading-tight mb-4" data-id="element-66">
          Lo que ya intentaste —{' '}
          <span className="green-highlight" data-id="element-67">y por qué no alcanzó:</span>
        </h2>

        <div className="space-y-2.5 mb-4" data-id="element-68">
          {items.map((it, i) => <div key={i} className="bg-white border-2 border-brand-navy/30 rounded-lg p-3 md:p-4 flex items-start gap-3" data-id="element-69">
              <div className="bg-brand-red/10 border-2 border-brand-red rounded-md p-1 shrink-0" data-id="element-70">
                <X className="w-4 h-4 text-brand-red" strokeWidth={3} data-id="element-71" />
              </div>
              <p className="text-sm md:text-base text-brand-ink leading-snug" data-id="element-72">
                <span className="font-display font-bold text-brand-navy uppercase" data-id="element-73">
                  {it.title}
                </span>{' '}
                <span className="font-medium text-brand-mute" data-id="element-74">{it.desc}</span>
              </p>
            </div>)}
        </div>

        <p className="text-center text-base md:text-xl font-display font-bold text-brand-navy uppercase leading-tight" data-id="element-75">
          El problema no es que te falte información. Es que{' '}
          <span className="text-brand-orange" data-id="element-76">
            nunca tuviste un sistema didáctico completo.
          </span>
        </p>
      </div>
    </section>;
}